import { Badge } from '@carbon/icons-react';
import { Link } from '@routable/gross-ds';
import React from 'react';
import { PLATFORM_URL } from 'constants/platform';
import { LEGAL, SECURITY } from 'constants/routes';
import {} from './SafeAndSecureBadge.types';
const SafeAndSecureBadge = ({ includeLink }) => {
    return (React.createElement("span", { className: "flex gap-2 items-center" },
        React.createElement(Badge, { size: 14 }),
        includeLink ? (React.createElement(Link, { href: `${PLATFORM_URL}${LEGAL}/${SECURITY}`, openInNewTab: true, showArrowIcon: false }, "Safe & secure")) : ('Safe & secure')));
};
export default SafeAndSecureBadge;
